import { Component, OnInit } from '@angular/core';
import {SttTableComponent} from '../../../../shared/components/stt-table/stt-table.component';
import {DialogService, DynamicDialogRef} from 'primeng/dynamicdialog';
import { UnitMeasureModel } from 'src/app/shared/entities/unit-measure.model';
import { UnitMeasureAddEditComponent } from '../unit-measure-add-edit/unit-measure-add-edit.component';
import { ConfirmationService, MessageService, PrimeNGConfig } from 'primeng/api';
import { ValidationMessageService } from '../../../../shared/services/base/validation-message-handle';
import { UnitMeasureService } from '../../../../shared/services/app/unit-measure.service';
import { finalize } from "rxjs/operators";

@Component({
  selector: 'app-unit-measure-action-table',
  templateUrl: './unit-measure-action-table.component.html',
  styleUrls: ['./unit-measure-action-table.component.scss']
})
export class UnitMeasureActionTableComponent implements OnInit {

  public data: UnitMeasureModel;
  public table: SttTableComponent;
  public ref: DynamicDialogRef;
  public loading = true;

  constructor(
      public dialogService: DialogService,
      public confirmationService: ConfirmationService,
      public primengConfig: PrimeNGConfig,
      public itemService: UnitMeasureService,
      public messageService: MessageService,
      private validationMessageService: ValidationMessageService,
  ) {

  }

  ngOnInit(): void {
  }

  setParams(entity: UnitMeasureModel): void {
      this.data = entity;
  }

  setTableReference(table: SttTableComponent): void
  {
      this.table = table;
  }


  showDialog() {
      this.ref = this.dialogService.open(UnitMeasureAddEditComponent, {
          header: 'Modificare Unitate de masura',
          width: '30%',
          contentStyle: {'max-height': '70vh'},
          baseZIndex: 10000,
          closeOnEscape: false,
          data: this.data,
      });

      this.ref.onClose.subscribe((unit_measure: UnitMeasureModel) => {
          if (unit_measure) {
              this.table.refresh();
          }
      });
  }

    confirm() {
        this.confirmationService.confirm({
            header: 'Confirmare stergere Unitate de Masura',
            message: 'Sunteti sigur ca doriti sa stergeti aceasta Unitate de masura?',
            key: 'deleteUnitMeasure',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Da',
            rejectLabel: 'Nu',
            acceptButtonStyleClass: 'p-button-md p-button-success',
            rejectButtonStyleClass: 'p-button-md p-button-danger',
            accept: () => {
                this.deleteItem(this.data.uid);
            },
            reject: () => {
                this.confirmationService.close();
                this.table.refresh();
            }
        });
    }

    deleteItem(uid: string){
        this.itemService.delete(uid)
            .pipe(finalize(() => {this.loading = false;this.table.refresh();}))
            .subscribe((response: any) => {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Unitatea de masura a fost stearsa cu success!'
                });
            });
    }

}
